export enum AppRoutePaths {
  LOGIN = '/',
  BIOMETRIC_LOGIN = '/manual',
  HOME = '/home',
  USERS = '/users',
  USERS_CREATE = '/users/create',
  ACCESS_CREATE = '/users/access-create',
  ACCESS_EDIT = '/users/access-edit/:id',
  USERS_EDIT = '/users/edit/:id',
  COMPANIES = '/companies',
  COMPANIES_CREATE = '/companies/create',
  COMPANIES_EDIT = '/companies/edit/:id',
  WORK_HISTORY = '/work-histories',
  WORK_HISTORY_CREATE = '/work-histories/create',
  CASH_FLOW = '/cash-flow',
  SALARY_CASH_FLOW = '/salary-cash-flow',
  REWARD_CASH_FLOW = '/reward-cash-flow',
  EMPLOYEE_TRANSPORT = '/employee-transport',
  NOT_FOUND = '*',
  BANK_HOURS = '/bank-hours',
  WORK_SCALE_CREATE = '/work-scale/create',
  WORK_SCALE_LIST = '/work-scale',
  WORK_SCALE_EDIT = '/work-scale/edit/:id',
  WORK_ALERTS = '/work-alerts',
  BANK_HOURS_HISTORY = '/bank-hours/:id/history',
  BANK_HOURS_REQUEST = '/bank-hours/request',
  EMPLOYEE_PAYSLIP = '/payslip/:hashcode',
  ACCESS_CODE_BIOMETRIC_LOGIN = '/login/access-code',
  EPIS = '/epis',
  EPI_CATALOG = '/epis/catalog',
  EPI_DELIVERIES = '/epis/deliveries',
  EPI_MATRIX = '/epis/matrix',
  EPI_ROUNDS = '/epis/rounds',
  EPI_REPORTS = '/epis/reports',
  SECTOR_DAILY_LOGS = '/sector-daily-logs',
  NOTIFICATIONS = '/notifications',
}
